import {
  ILoyaltyServiceTransactionFragment,
  ITransactionFragment,
  LoyaltyServicePromotionType,
} from 'generated/graphql-gateway';

import { LoyaltyTransaction } from './types';

export const mapLegacyTransaction = (transaction: ITransactionFragment): LoyaltyTransaction => ({
  channel: transaction.channel,
  pointsEarned: transaction.pointsEarned,
  bonusPointsEarned: transaction.bonusPointsEarned,
  pointsUsed: transaction.pointsUsed,
  pointsDeducted: transaction.pointsDeducted,
  hasRewards: transaction.hasRewards,
  transactionDetails: transaction.transactionDetails
    ? {
        payments: transaction.transactionDetails.payments.map(({ amount }) => ({ amount })),
      }
    : transaction.transactionDetails,
  createdAt: transaction.createdAt,
  additionalReferenceIds: transaction.additionalReferenceIds?.map(({ id, type }) => ({ id, type })),
});

export const mapServiceTransaction = (
  transaction: ILoyaltyServiceTransactionFragment
): LoyaltyTransaction => ({
  channel: transaction.channel,
  pointsEarned: transaction.pointsEarned,
  bonusPointsEarned: transaction.bonusPointsEarned,
  pointsUsed: transaction.pointsUsed,
  pointsDeducted: transaction.pointsDeducted,
  hasRewards:
    transaction.transactionDetails?.promotions?.some(
      promotion => promotion.type === LoyaltyServicePromotionType.REWARD
    ) ?? false,
  transactionDetails: transaction.transactionDetails
    ? {
        payments: transaction.transactionDetails.payments.map(({ amount }) => ({ amount })),
      }
    : transaction.transactionDetails,
  createdAt: transaction.createdAt,
  additionalReferenceIds: transaction.additionalReferenceIds?.map(({ id, type }) => ({ id, type })),
});
